import { useMemo } from "react";
import { TableState } from "@/types/tableState.types";
import { Workspace } from "@/components/UI/TableToolbar/WorkspaceButton/workspace";

export function useTemplateDrift(
  currentTableState: TableState,
  currentWorkspace: Workspace | null,
): boolean {
  return useMemo(() => {
    if (!currentWorkspace?.is_vivo_template) return false;
    if (!currentTableState.workspaceId) return false;
    if (!currentTableState.workspaceModifiedAt) return false;
    if (currentTableState.workspaceId !== currentWorkspace.id) return false;
    return (
      currentTableState.workspaceModifiedAt !== currentWorkspace.modified_at
    );
  }, [
    currentTableState.workspaceId,
    currentTableState.workspaceModifiedAt,
    currentWorkspace,
  ]);
}
